
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import TextField from '../../../../framework/fields/TextField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';

import { sharedState } from '../../../../framework/state';
import { getResource, putResource } from '../../../../framework/client/resource';
import { getEnumerationOptions, OptionValue } from '../../../../framework/service/options';

import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { VehicleMakeType } from '../../../../../common/application/model/enums/VehicleMakeType';
import { VehicleMake } from '../../../../../common/application/model/VehicleMake';

import { successToast, errorToast } from '../../../service/toast_service';

@Component({
    components: { SelectField, TextField, ValidationObserver },
})
export default class EditVehicleMake extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.VEHICLE_MAKE;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as VehicleMake,
        vehicleMakeTypeOptions: [] as OptionValue[],
    };

    // Functions
    async mounted() {
        this.local.vehicleMakeTypeOptions = getEnumerationOptions(
            'VehicleMakeType',
            Object.keys(VehicleMakeType),
            this,
        );
        this.local.row = (await getResource<VehicleMake>(this.resourceType, this.id))!!;
    }

    save() {
        this.saveResource(false);
    }

    saveAndClose() {
        this.saveResource(true);
    }

    private async saveResource(goBack: boolean) {
        try {
            await putResource<VehicleMake>(this.resourceType, this.id, this.local.row);
            successToast(this, 'message.vehicleMakeSaved');

            if (goBack) {
                this.back();
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
